import React, { useCallback, useState, useEffect } from 'react';
import { Button, Spinner } from 'reactstrap';
import clsx from 'clsx';
import propTypes from 'prop-types';

import './styles.scss';

const LoadingButton = ({
  loading,
  error,
  children,
  className,
  onClick,
  pure,
  ...props
}) => {
  const [didMount, setDidMount] = useState(false);
  const [status, setStatus] = useState(false);

  const handleSetStatus = useCallback((newStatus) => {
    setStatus(newStatus);
    const timeout = setTimeout(() => setStatus(null), 4000);
    return () => clearTimeout(timeout);
  }, []);

  const handleClick = useCallback(
    (e) => {
      if (!loading && !status && onClick) {
        e.persist();
        onClick(e);
      }
    },
    [loading, onClick, status],
  );

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    if (didMount && !loading && !pure) {
      return handleSetStatus(error ? 'error' : 'success');
    }
    return undefined;
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [loading]);

  return (
    <Button
      {...props}
      onClick={handleClick}
      className={clsx('position-relative', className)}
      {...(status
        ? { outline: false, color: status === 'success' ? 'success' : 'danger' }
        : {})}
    >
      <span className={loading || status ? 'invisible' : 'visible'}>
        {children}
      </span>
      {(loading || status) && (
        <div className="em-loading-btn__status">
          {loading && <Spinner size="sm" type="grow" />}
          {!loading && status === 'success' && (
            <i
              className="ni ni-check-single ni-lg em-pulsed text-white position-relative"
              style={{ top: '1px' }}
            />
          )}
          {!loading && status === 'error' && (
            <i
              className="ni ni-e-remove ni-lg em-pulsed text-white position-relative"
              style={{ top: '1px' }}
            />
          )}
        </div>
      )}
    </Button>
  );
};

LoadingButton.propTypes = {
  children: propTypes.node,
  error: propTypes.bool,
  loading: propTypes.bool,
  className: propTypes.string,
  onClick: propTypes.func,
  pure: propTypes.bool,
};

export default LoadingButton;
